require('./contractEasyLoanTypeCSuccessStep.scss');

const PropTypes = require('prop-types');

// @ vendors    
const React = require('react');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
//@utilities
const { recordLinkV2 } = require('utilities/tagging');
const { getFormattedString } = require('utilities/currencyHelper');
//@constants
const { PERCENTAGE_SYMBOL } = require('constants/index');
const { catalogue, analyticsId, recordEasyLoanCBackGlobalPositionButton} = require('../analytics/contractEasyLoanTypeC.tracking');

class ContractEasyLoanTypeCSuccessStep extends React.Component {

    constructor(props) {
        super(props);

        this.handleMainButtonClick = this.handleMainButtonClick.bind(this);
    }

    componentDidMount() {
        recordLinkV2(
            catalogue[analyticsId.CONTRACT_EASY_LOAN_STEP_3_SUCCESS]()
        );
    }
    componentWillUnmount() {
        const { onLeave } = this.props;
        onLeave();
    }
    buildList() {
        const { immContractEasyLoan } = this.props;

        const fields = [
            {
                title: formatText('contractEasyLoanTypeCSuccess-loanImport'),
                bodyText: getFormattedString({
                    amount: immContractEasyLoan.get('selectedAmount'),
                    decimalsLength: 0,
                    currency: immContractEasyLoan.get('currency')
                })
            },
            {
                title: formatText('contractEasyLoanTypeCSuccess-anualTin'),
                bodyText: this.formatInterest(immContractEasyLoan.get('tin'))
            },
            {
                title: formatText('contractEasyLoanTypeCSuccess-term'),
                bodyText: formatText('contractEasyLoanTypeCSuccess-termMonths', [immContractEasyLoan.get('selectedTerm')])
            },
            {
                title: formatText('contractEasyLoanTypeCSuccess-monthlyInstallment'),
                bodyText: getFormattedString(immContractEasyLoan.get('installment'))
            },
            {
                title: formatText('contractEasyLoanTypeCSuccess-TAE'),
                bodyText: this.formatInterest(immContractEasyLoan.get('tae'))
            },
        ];

        return fields.map((field, index) => {
            return (
                <OKInformativeListItem
                    key={field.title + index}
                    title={field.title}
                    bodyText={field.bodyText}
                />
            );
        });
    }

    formatInterest(value) {
        return value.toString().replace(/\./, ',').concat(' ', PERCENTAGE_SYMBOL);
    }

    handleMainButtonClick() {
        const { goToGlobalPosition } = this.props;
        recordEasyLoanCBackGlobalPositionButton()
        goToGlobalPosition();
    }

    render() {
        const { immContractEasyLoan } = this.props;
        const title = formatText('contractEasyLoanTypeCSuccess-title');
        const subMessage = (
            <span>
                <FormattedText value="contractEasyLoanTypeCSuccess-reviewingDocumentation" />
                <span className="contract-easy-loan-success-step__account">
                </span>
            </span>
        );

        const listItems = this.buildList();

        const goToGlobal = {
            label: formatText('contractEasyLoanTypeCSuccess-goToGlobal').toUpperCase(),
            url: 'myprofile/global'
        };

        return (
            <article className="contract-easy-loan-success-step row no-gutter">
                <div className="col-xs-offset-1 col-xs-9">
                    <WizardSuccess
                        successMessage={title}
                        successSubMessage={subMessage}
                        mainButton={goToGlobal}
                        secondaryButtonStyle="link-complementary"
                        tealium={catalogue[analyticsId.CONTRACT_EASY_LOAN_WIZARD_SUCCESS]({ data: immContractEasyLoan.get('minTae') })}
                        isSecondVersion
                        onMainButtonClick={this.handleMainButtonClick}
                    >
                        <div className="contract-easy-loan-success-step__separator" />
                        <OKInformativeList columns={2}>
                            {listItems}
                        </OKInformativeList>
                    </WizardSuccess>
                </div>
            </article>
        );
    }
}

ContractEasyLoanTypeCSuccessStep.propTypes = {
    immContractEasyLoan: PropTypes.object.isRequired,
    goToGlobalPosition: PropTypes.func.isRequired,
    onLeave: PropTypes.func.isRequired,
};

module.exports = ContractEasyLoanTypeCSuccessStep;
